exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-label[_v-1ed7a2c4]{padding:4px 0}.profile-textfield[_v-1ed7a2c4]{margin-top:-20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1ed7a2c4&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/forms/ParametersForm.vue
// module id = 264
// module chunks = 0